export default __webpack_public_path__ + "static/media/Snd4.83f83132.mp3";